import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TarriffRoutingModule } from './tarriff-routing.module';
import { TarriffComponent } from './tarriff/tarriff.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatIconModule, MatListModule, MatTooltipModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatMenuModule, MatTableModule, MatAutocompleteModule, MatChipsModule, MatInputModule, MatStepperModule, MatTabsModule } from '@angular/material';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CheckBoxModule, ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DataTablesModule } from 'angular-datatables';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { SharedModule } from '../theme/shared/shared.module';
import { InitiateTarriffComponent } from './dialog/initiate-tarriff/initiate-tarriff.component';
import { TarriffDataTableComponent } from './tarriff-data-table/tarriff-data-table.component';
import { SharedComponentModule } from '../shared-component/shared-component.module';
import { CardModule } from '../theme/shared/components';
import { UpdateDialogComponent } from './dialog/update-dialog/update-dialog.component';
import { DeleteDialogComponent } from './dialog/delete-dialog/delete-dialog.component';


@NgModule({
  declarations: [TarriffComponent, InitiateTarriffComponent, TarriffDataTableComponent, UpdateDialogComponent, DeleteDialogComponent],
  imports: [
    CommonModule,
    TarriffRoutingModule,
    Ng4LoadingSpinnerModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    CardModule,
    NgMultiSelectDropDownModule,
    MultiSelectAllModule,
    MatDialogModule,
    MatTabsModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatMenuModule,
    MatTableModule,
    MatIconModule,
    MatListModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatStepperModule,
    MatChipsModule,
    DataTablesModule,
    SharedComponentModule,
    SharedModule
  ],
  entryComponents: [InitiateTarriffComponent,UpdateDialogComponent,DeleteDialogComponent]

})
export class TarriffModule { }
